import { getShape } from '@/modules/Node';
import type { ShapeNode, Point } from '@/modules/Node';

export interface ShapeContextSettings {
  ctx: Path2D;
  node: ShapeNode;
  center: Point;
  zoomLevel?: number;
  border?: boolean;
}

export default function useShapeUtils(): { addShapeToContext: (settings: ShapeContextSettings) => void } {

  function addShapeToContext({ ctx, node, center, zoomLevel = 1, border = false }: ShapeContextSettings): void {
    const shapeDef = getShape(node.shape);
    shapeDef.drawPath({ ctx, node, center, zoomLevel, border });
  }

  return {
    addShapeToContext,
  };
}
